import { render } from "./LoginV2.vue?vue&type=template&id=73b2b7c0"
import script from "./LoginV2.vue?vue&type=script&lang=js"
export * from "./LoginV2.vue?vue&type=script&lang=js"

import "./LoginV2.vue?vue&type=style&index=0&id=73b2b7c0&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__